import PropTypes from "prop-types";
import Desktop from "./InstructionCardDesktop";
import Mobile from "./InstructionCardMobile";

const InstructionCard = ({ ...props }) => (
	<>
		{
			props.isMobile
				? (
					<Mobile
						{...props}
					/>
				)
				: (
					<Desktop
						{...props}
					/>
				)
		}
	</>
);

InstructionCard.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	instructions: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		img: PropTypes.string,
		content: PropTypes.string,
	})),
};

InstructionCard.defaultProps = {
	instructions: [],
};

export default InstructionCard;
